 export const LOGIN_SUCCESS  = 'LOGIN_SUCCESS';
 export const LOGIN_FAILED   = 'LOGIN_FAILED';

 export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
 export const LOGOUT_FAILED  = 'LOGOUT_FAILED';

 export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
 export const SIGNUP_FAILED  = 'SIGNUP_FAILED';

 export const RESET_SUCCESS = 'RESET_SUCCESS';
 export const RESET_FAILED  = 'RESET_FAILED';

 export const LANGUAGE_CHANGE = 'LANGUAGE_CHANGE';


//emoticonReducer actionTypes
 export const EMOTICON_REQUEST = 'EMOTICON_REQUEST'
 export const EMOTICON_SUCCESS = 'EMOTICON_SUCCESS'
 export const EMOTICON_FAILURE = 'EMOTICON_FAILURE'
 export const EMOTICON_CANCEL  = 'EMOTICON_CANCEL'
